import React, { useEffect, useState } from "react";
import "./NotNetwork.scss";
import NetsLogo from "../../UI/NetsLogo/NetsLogo";
import NotNtworkItem from "./NotNtworkItem/NotNtworkItem";
import AdminMenuModule from "../../Modules/AdminModules/AdminMenuModule/AdminMenuModule";
import NotNtworkCard from "./NotNtworkCard/NotNtworkCard";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useError } from "../Admin/ErrorRequest/ErrorProvider";
import { myTarifs } from "../../Modules/AdminModules/AdminHomeModule/AdminHomeLogic/AdminHomeLogic";
import { handleError } from "../../Modules/AdminModules/ErrorModule/ErrorModule";
import Footer from "../General/Footer/Footer";
import { urlAdmin } from "../../Modules/AdminModules/urlAdminApi/urlAdmin";
import axios from "axios";
const NotNetwork = () => {
  const [searchParams] = useSearchParams();
  const mac = searchParams.get('mac')
  const { showError } = useError();
  const navigate = useNavigate();
  const [myTarif, setMytarif] = useState();
  const [lang, setLang] = useState(localStorage.getItem("lang") || "RU");
  // Без ?mac в адресе запрос уходил как mac_address=null и стабильно давал
  // 404 — на странице он всё равно ничего не даёт, поэтому не делаем его.
  const getMacToken = () => {
    if (!mac) return;
    axios.get(`${urlAdmin}account/mac?mac_address=${encodeURIComponent(mac)}`).then(res=> {
      setMytarif(res.data)
    }).catch(err=>{
      console.log(err, 'errrrrrr')
    })
  }
  useEffect(()=> {
    getMacToken()
  },[mac])
  const langChange = (e) => {
    const selectedLang = e.target.value;
    localStorage.setItem("lang", selectedLang);
    setLang(selectedLang);
  };

 
  return (
    <>
      <div className="notNetwork_container">
        <div className="notNetwork_block">
          <div className="notNetwork_logo">
            <div className="fake"></div>
            <NetsLogo width={150} height={20} />
            <select
              name="language"
              id="language"
              onChange={langChange}
              value={lang}
            >
              <option value="RU">РУС</option>
              <option value="TJ">ТОҶ</option>
            </select>
          </div>

          <div className="notNetwork_item">
            <NotNtworkItem price={myTarif?.price}/>
          </div>
          <div className="notNetworkCards_block">
            <AdminMenuModule myTarif={myTarif?.tarif} dataClient={myTarif?.account}/>
            <NotNtworkCard />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotNetwork;
